module.exports = __webpack_public_path__ + "media/images/official/about_point3-39d42cf9495318d0cb30a6cc4525edff.jpg";